import { render, staticRenderFns } from "./LiveStage.vue?vue&type=template&id=3c1ad2c9&scoped=true"
import script from "./LiveStage.vue?vue&type=script&lang=js"
export * from "./LiveStage.vue?vue&type=script&lang=js"
import style0 from "./LiveStage.vue?vue&type=style&index=0&id=3c1ad2c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1ad2c9",
  null
  
)

export default component.exports